<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
        <div id="pagebody" class="container">
      <Contactinfo id="contactinfo"></Contactinfo>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//test comment 2
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');
import Navbar from '@/components/Navbar'
import Contactinfo from '@/components/Contactinfo'

export default {
  name: 'home',
  components: {
    Navbar,
    Contactinfo
  },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<style >
#navbar {
  margin-bottom: 80px;
}


</style>
